var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.261 9.20482C16.0266 9.43916 15.7087 9.5708 15.3772 9.5708C15.0458 9.5708 14.7279 9.43916 14.4935 9.20482L8.30597 3.01732L2.11847 9.20482C1.88272 9.43252 1.56696 9.55851 1.23922 9.55566C0.91147 9.55281 0.597954 9.42135 0.366194 9.18959C0.134434 8.95783 0.00297356 8.64432 0.000125885 8.31657C-0.00272179 7.98882 0.123272 7.67307 0.350969 7.43732L7.42222 0.366068C7.65663 0.131728 7.97451 8.39233e-05 8.30597 8.39233e-05C8.63742 8.39233e-05 8.95531 0.131728 9.18972 0.366068L16.261 7.43732C16.4953 7.67173 16.627 7.98961 16.627 8.32107C16.627 8.65252 16.4953 8.97041 16.261 9.20482Z",
    fill: "#CECECE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.c103a32206038115588778b437835fef.svg";
export { ForwardRef as ReactComponent };